import * as React from 'react';

import MUIDivider, { DividerProps } from '@mui/material/Divider';

export const Divider = (props: DividerProps) => {
	return <MUIDivider {...props} />;
};
